import { render, staticRenderFns } from "./pubsfc.vue?vue&type=template&id=47def0bf&scoped=true&"
import script from "./pubsfc.vue?vue&type=script&lang=js&"
export * from "./pubsfc.vue?vue&type=script&lang=js&"
import style0 from "./pubsfc.vue?vue&type=style&index=0&id=47def0bf&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47def0bf",
  null
  
)

export default component.exports